import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development scope-template routes.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentScopeTemplatesRoute = defineRoute(`${developmentRoute.path}/templates`);
export const developmentScopeTemplateRoute = defineRoute(`${developmentRoute.path}/templates/:itemTemplateId`);
export const developmentScopeTemplateItemRoute = defineRoute(
  `${developmentRoute.path}/templates/:itemTemplateId/:itemTemplateItemId`,
);
export const developmentScopeTemplateCostReportRoute = defineRoute(
  `${developmentRoute.path}/templates/cost/:itemTemplateId`,
);
export const developmentReviewTemplatesRoute = defineRoute(`${developmentRoute.path}/templates/review`);
